import React, { Suspense } from 'react';
import styles from './PlayableWrapper.module.css'; // Import the CSS module

interface PlayableWrapperProps {
  component: React.ComponentType<any>;
  [key: string]: any; // Allow any additional props
}

const PlayableLoadingFallback = () => (
  <div className={styles.loadingContainer}>
    <div className={styles.loadingContent}>
      <div className={styles.spinner} />
      <p className={styles.loadingText}>Loading...</p>
    </div>
  </div>
);

const PlayableWrapper: React.FC<PlayableWrapperProps> = ({ component: Component, ...props }) => {
  return (
    <Suspense fallback={<PlayableLoadingFallback />}>
      <Component {...props} />
    </Suspense>
  );
};

export default PlayableWrapper; 